// import { rootStore } from 'cv-react-core';

// Core component styles
const coreStyles = {
    button: {
        padding: '0px',
    },

    container: {
        padding: '5px',
        flexShrink: 0,
        borderColor: '#E0E0E0',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
    },

    icon: {
    },

    text: {
    },
};

/**
 * Helper method to get the styles for the component
 * @param {Object} contextStyles - Context styles for the Component
 */
const getStyles = (contextStyles = {}) => {
    // const { themeStore } = rootStore;
    // const theme = themeStore.getSanitizedTheme();

    return {
        button: {
            ...coreStyles.button,
            ...contextStyles.button,
        },

        container: {
            ...coreStyles.container,
            ...contextStyles.container,
        },

        icon: {
            ...coreStyles.icon,

            // color: theme.actionButtonBackgroundColor,
            ...contextStyles.icon,
        },

        text: {
            ...coreStyles.text,
            ...contextStyles.text,
        },
    };
};

export default getStyles;
